import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** リース料支払いサイクル */
enum PaymentCycle {
  everyMonth = '1',
  everyTwoMonths = '2',
  everyThreeMonths = '3',
  everyFourMonths = '4',
  semiannually = '5',
  annually = '6',
  unset = '9',
}

const nameConfig = {
  everyMonth: new Map([[Locale.ja, '毎月']]),
  everyTwoMonths: new Map([[Locale.ja, '2ヶ月毎']]),
  everyThreeMonths: new Map([[Locale.ja, '3ヶ月毎']]),
  everyFourMonths: new Map([[Locale.ja, '4ヶ月毎']]),
  semiannually: new Map([[Locale.ja, '半年毎']]),
  annually: new Map([[Locale.ja, '1年毎']]),
  unset: new Map([[Locale.ja, '未設定']]),
};

const toEnum = rawValueToEnum(PaymentCycle, PaymentCycle.unset);
const toDisplay = enumToName(PaymentCycle, nameConfig);
const toDisplayWithPrefix = enumToName(PaymentCycle, nameConfig, { prefix: true });

export const paymentCycle = {
  enum: PaymentCycle,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PaymentCycle };
